<template>
    <div>
        <LabelList :type="type"></LabelList>
    </div>
</template>

<script>
    import LabelList from './components/labelList';

    export default {
        name: "Project",
        components: {
            LabelList
        },
        data() {
            return {
                type:"PROJECT_LABEL"
            };
        }
    }
</script>

<style lang="less" scoped>

</style>